/**
 * 立项决策卡片组件
 */

import React from 'react';
import { Card, Form, Row, Col, Input, Select } from 'antd';
import { RECOMMENDATION_OPTIONS } from './constants';

const { TextArea } = Input;

export const DecisionCard: React.FC = () => {
    return (
        <Card title="📋 立项决策" bordered={false}>
            <Row gutter={24}>
                <Col span={12}>
                    <Form.Item
                        name={['research_data', 'recommendation']}
                        label="立项建议"
                    >
                        <Select
                            options={RECOMMENDATION_OPTIONS as any}
                            placeholder="选择建议"
                        />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item
                        name={['research_data', 'conclusion']}
                        label="调研结论"
                    >
                        <TextArea
                            rows={4}
                            placeholder="综合以上调研，总结产品是否值得立项开发..."
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};

export default DecisionCard;
